import { StatCard } from "@design-system/StatCard/StatCard";

type Props = {
  totalEmployeesAuthenticated?: number;
};

export const ResourceGroupAuthenticatedUsersStat = ({
  totalEmployeesAuthenticated,
}: Props) => {
  return (
    <StatCard
      icon="faUser"
      title="Authenticated users"
      value={totalEmployeesAuthenticated?.toString() ?? "0"}
    />
  );
};